export default "__VITE_ASSET__DQEft6HH__"